export const Experiments: Record<string, string> = {
  Experiment1CombineProviderAndAvailability:
    "experiment-1-combine-provider-steps",
  ExperimentClientPackageSuggestions: "experiment-client-package-suggestions",
};

export const ExperimentVariants = {
  // Experiment completed - variant won, keeping this for historic purposes
  [Experiments.Experiment1CombineProviderAndAvailability]: {
    Control: "control-separate-provider-step",
    VariantA: "variant-a-combined-provider-and-availability",
  },
  [Experiments.ExperimentClientPackageSuggestions]: {
    Control: "control-no-package-suggestions",
    VariantA: "variant-a-client-package-suggestions",
  },
};
